import { autoinject } from "aurelia-framework";

@autoinject
export class DecentlabWaterLevelRuleEditor {

	minimum: number;
	recommended: number;
}
